import { ElementSource } from "chq";

import { ElementState } from "@creatomate/preview";
import createSubtitleElement from "./createSubtitleElement";

export const getPercentageofSentence = (sentence: string, percentage: number) => {
  if (percentage <= 0) {
    return {
      cutOffSentence: "",
      restOfTheSentence: sentence
    };
  }

  // Split the sentence into individual words
  const words = sentence.split(" ");
  // Calculate the percentage of the total number of words and round it up
  const percent = Math.ceil(words.length * (percentage / 100));
  // Extract the first words and join them back into a sentence
  const cutOffSentence = words.slice(0, percent).join(" ");
  // Extract the rest of the words and join them back into a sentence
  const restOfTheSentence = words.slice(percent).join(" ");

  return {
    cutOffSentence,
    restOfTheSentence
  };
};

const getSplittedSentence = (
  text: string, sectionEndtime: number, sectionStartTime: number, currentTime: number
) => {
  const sectionDuration = sectionEndtime - sectionStartTime;
  const currentTimeInSection = currentTime - sectionStartTime;
  const percentageInSection = (currentTimeInSection * 100) / sectionDuration;

  return getPercentageofSentence(text, percentageInSection);
};

const splitSection = (
  subtitleElement: ElementSource,
  currentTime: number,
  organization: string,
  index: number,
  newElement: ElementSource,
  rendererElements: ElementState[]
): ElementSource[] => {
  const splittedSubtitleElements: ElementSource[] = [];
  const endTime = subtitleElement.time + subtitleElement.duration;
  const { cutOffSentence, restOfTheSentence } = getSplittedSentence(
    subtitleElement.text, endTime, subtitleElement.time, currentTime
  );
  const [_prefix, _index, language] = subtitleElement.name.split("-", 3);

  splittedSubtitleElements.push({
    ...subtitleElement,
    text: cutOffSentence,
    duration: currentTime - subtitleElement.time
  });
  splittedSubtitleElements.push(createSubtitleElement(
    restOfTheSentence,
    index,
    currentTime + 0.01,
    endTime,
    subtitleElement.track,
    organization,
    newElement.id,
    language,
    rendererElements.find(e => e.source.id === subtitleElement.id),
    false
  ));
  return splittedSubtitleElements;
};

const splitSubtitle = (
  allSubtitleElements: ElementState[],
  currentTime: number,
  organization: string,
  newElement: ElementSource,
  rendererElements: ElementState[] = []
): ElementSource[] => {
  const updatedSubtitleElements: ElementSource[] = [];

  allSubtitleElements.forEach((subtitleElement: ElementState) => {
    const endTime = subtitleElement.globalTime + subtitleElement.duration;
    const isCurrentTimeInRange = subtitleElement.globalTime <= currentTime
      && endTime >= currentTime;

    if (isCurrentTimeInRange) {
      updatedSubtitleElements.push(...splitSection(
        subtitleElement.source,
        currentTime,
        organization,
        allSubtitleElements.length,
        newElement,
        rendererElements
      ));
    } else if (subtitleElement.globalTime > newElement.time) {
      const [prefix, _oldRef] = subtitleElement.source.name.split("-REF=", 2);
      updatedSubtitleElements.push({
        ...subtitleElement.source,
        name: `${prefix}-REF=${newElement.id}`
      });
    } else {
      updatedSubtitleElements.push(subtitleElement.source);
    }
  });

  return updatedSubtitleElements;
};

export default splitSubtitle;
